import App from './app/app.svelte';

const app = new App({target: document.body});

export default app;
